import { InputUnstyled } from "@mui/base";
import { NoEncryption, Search } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Box, Grow, InputBase, Paper, Slide, TextField, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import { jobInfo } from "../../stores/request";

export default function SearchTask() {
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchHelper, setSearchHelper] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);

  const navigate = useNavigate();

  const onSearch = useCallback(async () => {
    if (!searchValue.match(/^\d{8,}$/)) {
      setSearchHelper("Please input right job id");
      return;
    }
    setSearchHelper("");
    let v_current = searchValue.slice(8);

    console.log(v_current);
    setSearchLoading(true);
    let result = await jobInfo(v_current);
    setSearchLoading(false);
    if (result.success) {
      navigate("/result?jobId=" + searchValue);
    }
    else {
      setSearchHelper(result.message);
    }
    console.log(result);
  }, [searchValue, navigate]);
  const handleKeyUp = useCallback(
    event => {
      if (event.keyCode === 13) {
        onSearch();
      }
    },
    [onSearch]
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "left",
        paddingTop: 2,
        paddingBottom: 2,
        paddingLeft: 0,
        paddingRight: 0,
        maxWidth: "calc(100vw - 20px)",
      }}
    >
      <Box sx={{
        position: "relative",
        minWidth: 0,
        flex: 1,
      }}>
        <Paper elevation={searchFocused ? 6 : 1} sx={{
          display: "flex",
          height: "100%",
          transform: searchFocused ? "scale(1.02)" : "scale(1)",
          transformOrigin: "bottom center",
          transitionProperty: "box-shadow, transform",
        }}>
          <InputBase
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            onFocus={() => setSearchFocused(true)}
            onBlur={() => setSearchFocused(false)}
            onKeyUp={handleKeyUp}
            placeholder="Input task id"
            sx={{
              pl: 1,
              pr: 1,
              width: 300,
            }}
          />
        </Paper>
        <Grow in={Boolean(searchHelper)} mountOnEnter unmountOnExit>
          <Paper sx={{
            position: "absolute",
            top: "100%",
            mt: 1,
            bgcolor: "error.light",
            color: "error.contrastText",
            pl: 1,
            pr: 1,
          }}>
            <Typography variant="body1" component="div">
              {searchHelper}
            </Typography>
          </Paper>
        </Grow>
      </Box>
      <LoadingButton
        loading={searchLoading}
        onClick={onSearch}
        loadingPosition="start"
        startIcon={<Search />}
        variant="contained"
        color="secondary"
        size="large"
        sx={{
          ml: 1,
          flexShrink: 0,
        }}
      >
        Search
      </LoadingButton>
    </Box>
  );
}
